import { combineReducers } from "redux";
import demographicsReducer from "./Demographics/demographics.reducers";

const rootReducer = combineReducers({
  demographics: demographicsReducer,
});

export default rootReducer;
